function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 26 26",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.516 21.484A12 12 0 1121.19 4.22 12 12 0 014.516 21.484zm15.276-1.692A9.606 9.606 0 106.207 6.208a9.606 9.606 0 0013.585 13.584zM11.8 14.2v-2.4h2.4V19h-2.4v-4.8zm0-7.2h2.4v2.4h-2.4V7z"
}));